import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    activeTab?: string;
}

type HandlerType = CustomHandler<Parameter>;

export const UpdateActiveTab: HandlerType = props => {
    props.dispatch({
        type: "Custom/SearchResults/SetActiveTab",
        activeTab: props.parameter.activeTab,
    });
};

export const chain = [UpdateActiveTab];

const setActiveTab = createHandlerChainRunner(chain, "setActiveTab");
export default setActiveTab;
